import { createFileRoute } from '@tanstack/react-router'
import { OpsConsole } from '@/pages/ops/OpsConsole'

export const Route = createFileRoute('/(protected)/ops/')({
  // `?tab=` selects the console tab, so operator surfaces are linkable — the
  // feature-board notification emails point at /ops?tab=feature-requests.
  // `?request=` highlights one feature request, used by the "Triage" shortcut on the board.
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    request: typeof search.request === 'string' ? search.request : undefined,
  }),
  component: OpsConsole,
})
